/**
 * Animations d'apparition des sections (viewer, au scroll).
 * Références motion (emil-design-eng) : entrée = ease-out custom, transform/
 * opacity uniquement, jamais scale(0), reduced-motion = fondu sans mouvement.
 */

export const APPEAR_ANIMATION_NONE = 'none';

export const APPEAR_ANIMATION_OPTIONS = [
  { value: 'none', label: 'Aucune' },
  { value: 'fade', label: 'Fondu' },
  { value: 'slide-up', label: 'Glissement' },
  { value: 'zoom', label: 'Zoom doux' },
];

const VALID_VALUES = APPEAR_ANIMATION_OPTIONS.map((o) => o.value);

/**
 * Variante → classe CSS. Les feuilles qui la consomment (ProposalSection,
 * hooks/blockAppearance) déclarent les mêmes noms de classes ; seule la
 * correspondance est commune.
 */
export const APPEAR_VARIANT_CLASS = {
  fade: 'appearFade',
  'slide-up': 'appearSlideUp',
  zoom: 'appearZoom',
};

/** Normalise une valeur stockée (legacy/inconnue → none). */
export function normalizeAppearAnimation(value) {
  return VALID_VALUES.includes(value) ? value : APPEAR_ANIMATION_NONE;
}

// Timing d'apparition (ms). Défaut lent (retour 2026-07-10) — une
// entrée trop rapide se voit à peine au scroll.
export const APPEAR_ANIMATION_DURATION_MIN_MS = 600;
export const APPEAR_ANIMATION_DURATION_MAX_MS = 3000;
export const APPEAR_ANIMATION_DURATION_STEP_MS = 100;
export const APPEAR_ANIMATION_DURATION_DEFAULT_MS = 1400;

/** Normalise une durée stockée (legacy/inconnue/hors bornes → défaut). */
export function normalizeAppearAnimationDuration(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return APPEAR_ANIMATION_DURATION_DEFAULT_MS;
  return Math.min(
    APPEAR_ANIMATION_DURATION_MAX_MS,
    Math.max(APPEAR_ANIMATION_DURATION_MIN_MS, n)
  );
}

/**
 * L'animation doit-elle être active ?
 * Jamais dans l'éditeur (vue des dizaines de fois par session — règle de
 * fréquence) ni sans IntersectionObserver (le contenu reste visible).
 */
export function isAppearAnimationActive(value, { isEditing = false } = {}) {
  if (isEditing) return false;
  if (normalizeAppearAnimation(value) === APPEAR_ANIMATION_NONE) return false;
  return (
    typeof window !== 'undefined' &&
    typeof window.IntersectionObserver === 'function'
  );
}
